import React from 'react';
import { Button } from '@mui/material';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const ExportPDF = ({ csvData, fileName, title, customerName, orientation = 'landscape' }) => {

    const exportToPDF = (csvData, fileName, title) => {
        if (!csvData || !csvData.length) return;

        const unit = "pt";
        const size = "A3"; // Using A3 for extra width
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(14);
        doc.setTextColor(40);

        // Title
        const reportTitle = title || "Data Report";
        const titleWidth = doc.getStringUnitWidth(reportTitle) * doc.internal.getFontSize();
        const titleX = (doc.internal.pageSize.width / 2) - (titleWidth / 2);
        doc.text(reportTitle, titleX, 35);

        doc.setFontSize(11);
        // Customer Name
        const customerText = customerName || localStorage.getItem('clientName') || 'N/A';
        const customerTextWidth = doc.getStringUnitWidth(customerText) * doc.internal.getFontSize();
        const customerTextX = (doc.internal.pageSize.width / 2) - (customerTextWidth / 2);
        doc.text(`Client: ${customerText}`, customerTextX, 55);

        // Date & User
        const todayDate = new Date().toLocaleDateString("en-GB");
        const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        const userFullName = localStorage.getItem('fullName') || '';
        const dateText = `${todayDate} at ${currentTime}`;

        // Headers
        const headers = Object.keys(csvData[0]).map(key =>
            key.replace(/([a-z])([A-Z])/g, "$1 $2")
                .replace(/\b\w/g, char => char.toUpperCase())
        );

        const data = csvData.map((obj, index) => [
            index + 1,
            ...Object.values(obj)
        ]);

        const finalHeaders = ["S.No", ...headers];

        doc.autoTable({
            startY: 80,
            head: [finalHeaders],
            body: data,
            theme: 'grid',
            headStyles: {
                fillColor: [50, 202, 115],
                textColor: [255, 255, 255],
                fontSize: 9,
                fontStyle: 'bold',
                halign: 'center'
            },
            bodyStyles: {
                fontSize: 8,
                textColor: [50, 50, 50],
                valign: 'middle'
            },
            alternateRowStyles: {
                fillColor: [248, 249, 250]
            },
            styles: {
                overflow: 'linebreak',
                cellPadding: 4,
                lineColor: [220, 220, 220],
                lineWidth: 0.1,
            },
            columnStyles: {
                0: { cellWidth: 35, halign: 'center' }, // S.No
            },
            margin: { top: 70, left: 20, right: 20, bottom: 40 },
            didDrawPage: (data) => {
                const pageCount = doc.internal.getNumberOfPages();
                doc.setFontSize(9);
                doc.setTextColor(100);

                // Footer text
                const footerText = `This report is generated from PND by ${userFullName} on ${dateText}`;
                const pageHeight = doc.internal.pageSize.height;
                const pageWidth = doc.internal.pageSize.width;

                doc.text(footerText, 20, pageHeight - 20);
                doc.text(`Page ${data.pageNumber} of ${pageCount}`, pageWidth - 60, pageHeight - 20);
            }
        });

        doc.save(`${fileName}_${todayDate.replace(/\//g, '-')}.pdf`);
    };

    return (
        <Button
            variant="contained"
            size="small"
            color="secondary"
            startIcon={<PictureAsPdfIcon />}
            onClick={() => exportToPDF(csvData, fileName, title)}
            sx={{ fontWeight: 'bold', borderRadius: '4px', textTransform: 'none' }}
        >
            PDF
        </Button>
    );
};

export default ExportPDF;